var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("读取给定地址的文件夹的文件，获取文件清单")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"请输入要读取的文件夹的地址","clearable":""},model:{value:(_vm.path),callback:function ($$v) {_vm.path=$$v},expression:"path"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getlistfiles}},[_vm._v("获取")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e92d317","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/exceltodb/listfiles.vue
// module id = null
// module chunks = 